module.exports = __webpack_public_path__ + "static/media/Grid.fb16ce17.jpg";